import { Skeleton } from "@/components/ui/skeleton"

/** Generic analytics-tab skeleton: header row + a couple of card-height blocks. */
export default function AnalyticsTabSkeleton() {
  return (
    <div className="mx-auto max-w-[1500px] space-y-5 p-4 md:p-7">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-2">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-3.5 w-96 max-w-full" />
        </div>
        <Skeleton className="h-9 w-40" />
      </div>
      <Skeleton className="h-64 w-full rounded-xl" />
      <Skeleton className="h-64 w-full rounded-xl" />
    </div>
  )
}
